import React from 'react'
import NextImage from 'next/image'

import { Button } from '@wartek-id/button-v1'
import {
  Dialog,
  DialogContent,
  DialogCloseButton,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type TDialogPelaksanaanAppealRejectedProps = {
  isOpen: boolean
  onClose: () => void
}
export const DialogPelaksanaanAppealRejected: React.FC<
  TDialogPelaksanaanAppealRejectedProps
> = ({ isOpen, onClose }) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      autoFocus={false}
      returnFocus={false}
    >
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <NextImage
            src="/illustrations/img-files-document-failed.png"
            width={84}
            height={84}
          />

          <div className="space-y-4">
            <Text variant="display-sm">Pengajuan perubahan ditolak</Text>
            <Text variant="body-lg" color="subdued">
              Anda tidak perlu mengulang hasil pemantauan Anda.
            </Text>
          </div>

          <div className="flex space-x-5">
            <Button
              data-testid="appeal-submitted-back-button"
              onClick={onClose}
              color="blue"
              size="lg"
              fullWidth
            >
              Saya mengerti
            </Button>
          </div>
        </div>
        <DialogCloseButton />
      </DialogContent>
    </Dialog>
  )
}
